<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - File: session-expired-dialog.vue
  - The session has expired: one action, "Sign in again" (board vue-figma-20261014-1, node 19085:17187).
  - It is mounted on its own by commons/session/SessionExpired.ts, often before the app itself, so it
  - uses nothing global: no i18n, no store, no router.
  - =============================================================================
  -->

<script>
import ZtnDialog from "@/components/input/ztn-dialog.vue";
import PageHelper from "@/services/PageHelper";

export default {
  name: "session-expired-dialog",
  components: {ZtnDialog},
  props: {
    team: {type: String, default: ""},
  },
  data() {
    return {
      open: true,
      leaving: false,
    };
  },
  computed: {
    body() {
      return this.team
          ? `Your sign-in to ${this.team} has expired. Sign in again to continue.`
          : "Your sign-in has expired. Sign in again to continue.";
    },
  },
  methods: {
    signInAgain() {
      if (this.leaving) {
        return;
      }
      this.leaving = true;
      PageHelper.Instance.goToSignInAgain();
    },
    // Nothing usable is behind this dialog, so it does not close: Esc (which ztn-dialog honours)
    // and the dialog's own close after confirm both put it straight back.
    keepOpen(value) {
      if (value) {
        return;
      }
      this.open = false;
      this.$nextTick(() => {
        this.open = true;
      });
    },
  },
};
</script>

<template>
  <ztn-dialog
      :model-value="open"
      title="Session expired"
      :show-close="false"
      :show-cancel-button="false"
      confirm-text="Sign in again"
      @update:model-value="keepOpen"
      @confirm="signInAgain"
  >
    {{ body }}
  </ztn-dialog>
</template>
